import { createTheme } from "@mui/material/styles";

const navy = "#1A3348";
const blue = "#1E5A8A";
const blueDark = "#154266";
const mist = "#F4F7FA";

const theme = createTheme({
  palette: {
    primary: {
      main: blue,
      dark: blueDark,
      light: "#3D7EB0",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: navy,
      dark: "#122536",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
    text: {
      primary: navy,
      secondary: "#4B5D6B",
    },
    divider: "rgba(26, 51, 72, 0.12)",
  },
  typography: {
    fontFamily: '"Source Sans 3", "Segoe UI", sans-serif',
    h1: { fontWeight: 750, letterSpacing: "-0.03em", lineHeight: 1.15 },
    h2: { fontWeight: 750, letterSpacing: "-0.02em", lineHeight: 1.2 },
    h3: { fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.25 },
    h4: { fontWeight: 700, lineHeight: 1.3 },
    h5: { fontWeight: 700, lineHeight: 1.35 },
    h6: { fontWeight: 700 },
    button: {
      fontWeight: 700,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 46,
          borderRadius: 10,
          paddingLeft: 20,
          paddingRight: 20,
          boxShadow: "none",
        },
        contained: {
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: blueDark,
            color: "#FFFFFF",
          },
          "& .MuiSvgIcon-root": {
            color: "#FFFFFF",
          },
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: blueDark,
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ":root": {
          "--color-navy": navy,
          "--color-blue": blue,
          "--color-mist": mist,
        },
      },
    },
  },
});

export default theme;
